import type { PageGuide } from "../page-guide.js";

/**
 * Help guide for Notes. Notes have no anchored panels wired yet, so the tour
 * steps render as centred workflow cards — still a useful first-run overview.
 */
export const notesGuide: PageGuide = {
  route: "/notes",
  version: 1,
  overviewArticleId: "notes-overview",
  steps: [
    {
      id: "capture",
      title: "Capture a note",
      body: "Notes are the written source of truth for lightweight thinking and meeting notes. Keep the important context in the body, not just the title.",
    },
    {
      id: "connect",
      title: "Connect your thinking",
      body: "Use **tags** to group related notes and **[[wikilinks]]** for named concepts or client work — both feed the Ideation graph.",
    },
    {
      id: "review",
      title: "Find and refine",
      body: "Search to surface earlier thinking, and open a note's detail page for focused editing and review.",
    },
  ],
  panels: [],
  guidedActions: [],
};
